















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import DisabledInput from '@/components/shared/DisabledInput.vue';

@Component({
  components: {
    DisabledInput
  },
})
export default class Summary extends Vue {
  private readonly emptyChainProperties: any =  {
        ss58Format: '',  
        tokenDecimals: '', 
        genesisHash: '', 
        tokenSymbol:''
    }
  public chainProperties: any = this.emptyChainProperties;
  public loading: boolean = false;

  @Watch('$store.state.chainProperties')
  public mapProp(): void {  
    this.chainProperties = {...this.emptyChainProperties, ...this.$store.state.chainProperties};
  }

  @Watch('$store.state.loading')
  public mapLoading(): void {  
    this.loading = this.$store.state.loading
  }

  public async mounted() {
    this.mapProp();
  }


}
